import {
    createHandlerChainRunner,
    Handler,
} from "@preferredMedical/HandlerCreator";

type HandlerType = Handler<{
    isBackordered: boolean;
}>;
export const DispatchSetIsBackordered: HandlerType = props => {
    props.dispatch({
        type: "Custom/Pages/OrderHistory/SetIsBackordered",
        isBackordered: props.parameter.isBackordered
    });
};

export const chain = [DispatchSetIsBackordered];

const setIsBackordered = createHandlerChainRunner(chain, "SetIsBackordered");
export default setIsBackordered;
